/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_PlanInputs */

const en_cp_mock_plan = /** @type {(inputs: Cp_Mock_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem Solver track · Phase 2 of 4`)
};

const id_cp_mock_plan = /** @type {(inputs: Cp_Mock_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalur Problem Solver · Fase 2 dari 4`)
};

/**
* | output |
* | --- |
* | "Problem Solver track · Phase 2 of 4" |
*
* @param {Cp_Mock_PlanInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_plan = /** @type {((inputs?: Cp_Mock_PlanInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_PlanInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_plan(inputs)
	return en_cp_mock_plan(inputs)
});